export const __setlocalStorage = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
* 获取 localStorage
*/
export const __getlocalStorage = name => {
  if (!name) return
  try {
    return JSON.parse(window.localStorage.getItem(name))
  } catch (e) {
    return window.localStorage.getItem(name)
  }
}

/**
* 删除 localStorage
*/
export const __removelocalStorage = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}
/* 

/**
* 清空 localStorage
*/
export const __clearlocalStorage = () => {
  window.localStorage.clear()
}


export const _PHONE = (func, num, p1, p2, p3, p4, p5, p6, p7) => {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //alert('是否是Android：'+isAndroid);
  //alert('是否是iOS：'+isiOS);
  if (isiOS) {
    var link = '';
    link = "XY://" + func;
    if (typeof (num) != 'undefined' && num > 0) {
      if (num >= 1) link += "?p1=" + encodeURIComponent(p1);
      if (num >= 2) link += "&p2=" + encodeURIComponent(p2);
      if (num >= 3) link += "&p3=" + encodeURIComponent(p3);
      if (num >= 4) link += "&p4=" + encodeURIComponent(p4);
      if (num >= 5) link += "&p5=" + encodeURIComponent(p5);
      if (num >= 6) link += "&p6=" + encodeURIComponent(p6);
      if (num >= 7) link += "&p7=" + encodeURIComponent(p7);
    }
    console.log(link);
    _IOSLOAD(link);
  }
  else {
    if (typeof (num) == 'undefined' || num == 0) eval(func + "()");
    else if (num == 1) eval(func + "( '" + p1 + "' )");
    else if (num == 2) eval(func + "( '" + p1 + "', '" + p2 + "' )");
    else if (num == 3) eval(func + "( '" + p1 + "', '" + p2 + "', '" + p3 + "' )");
    else if (num == 4) eval(func + "( '" + p1 + "', '" + p2 + "', '" + p3 + "', '" + p4 + "' )");
    else if (num == 5) eval(func + "( '" + p1 + "', '" + p2 + "', '" + p3 + "', '" + p4 + "', '" + p5 + "' )");
    else if (num == 6) eval(func + "( '" + p1 + "', '" + p2 + "', '" + p3 + "', '" + p4 + "', '" + p5 + "', '" + p6 + "' )");
    else if (num == 7) eval(func + "( '" + p1 + "', '" + p2 + "', '" + p3 + "', '" + p4 + "', '" + p5 + "', '" + p6 + "', '" + p7 + "' )");
  }
  return false;
}

// 扫码
export const _IOSLOAD = url => {
  var ifrm = document.createElement('iframe');
  ifrm.setAttribute('style', 'display:none;');
  ifrm.setAttribute('frameborder', '0');
  ifrm.setAttribute('height', '0px');
  ifrm.setAttribute('width', '0px');
  ifrm.setAttribute('src', url);
  document.body.appendChild(ifrm);
  ifrm.parentNode.removeChild(ifrm);
  ifrm = null;
}

/*
* @获取当前日期
* */
export const getNowDate = () => {
  let nowDate = new Date();
  let year = nowDate.getFullYear();
  let month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
  let day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
  let dateStr = year + "-" + month + "-" + day;
  return dateStr;
}

/**
 * 转化时间的格式
 * 'yyyy-MM-dd'
 */
export const formatDate = (date, fmt = 'yyyy-MM-dd') => {
  if (typeof (date) === 'string') {
    date = new Date(date)
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}
const createWeeks = function* (year) {
  const ONE_DAY = 24 * 3600 * 1000;
  let start = new Date(year, 0, 1),
    end = new Date(year, 11, 31);
  let firstDay = start.getDay() || 7,
    lastDay = end.getDay() || 7;
  let startTime = +start,
    endTime = startTime + (7 - firstDay) * ONE_DAY,
    _endTime = end - (7 - lastDay) * ONE_DAY;
  yield [startTime, endTime];
  startTime = endTime + ONE_DAY;
  endTime = endTime + 7 * ONE_DAY;
  while (endTime < _endTime) {
    yield [startTime, endTime];
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
  }
  yield [startTime, +end];
}
const matDate = (mill, type = "monthday") => {
  var y = new Date(mill);
  if (type == "monthday") {
    let raws = [
      formatDig(y.getMonth() + 1),
      formatDig(y.getDate()),
    ];
    let format = ['-'];
    return String.raw({
      raw: raws
    }, ...format);
  } else if (type == "month") {
    // return raws[0]
    return (y.getMonth() + 1)
  } else if (type == "monthsign") {
    let format = ['.'];
    let raws = [
      y.getMonth() + 1,
      y.getDate()
    ]
    return String.raw({
      raw: raws
    }, ...format);
  }

}
export const GetDateStr = (AddDayCount = 0) => {
  let date = new Date()
  date.setDate(date.getDate() + AddDayCount) //获取AddDayCount天后的日期
  let y = date.getFullYear()
  let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1 //获取当前月份的日期，不足10补0
  let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() //获取当前几号，不足10补0
  return y + '/' + m + '/' + d
}
const formatDig = (num) => {
  return num > 9 ? '' + num : '0' + num;
  return num;
}
export const monthWeekDate = (year) => {
  console.log(year)
  let currentYear = new Date().getFullYear()
  let currentMonth = new Date().getMonth() + 1
  let currentDate = new Date().getDate()
  let ms = new Date(`${currentYear}/${currentMonth}/${currentDate}`).getTime()
  // console.log(ms)
  let yearArray = []
  let currentMonthArray = []
  for (var i = currentYear; i >= year; i--) {
    yearArray.push(i)
  }
  for (var i = currentMonth; i >= 1; i--) {
    currentMonthArray.push(i)
  }
  let weeksArray = {} //计算year年至今的所有周
  let arr = []
  for (var i = 0; i < yearArray.length; i++) {
    // console.log(i)
    let index = 1;
    let temp = []
    let obj = {
      year: yearArray[i],
      week: [],
      monthWeek: [],
      month: [],
      dates: []
    }
    let month = ""
    for (let j of createWeeks(yearArray[i])) {
      let start = j[0],
        end = j[1];
      month = matDate(start, "month")
      // if (end <= new Date().getTime() || (start <= new Date().getTime() && end >= new Date().getTime())) {
      obj.week.push({
        start: matDate(start),
        end: matDate(end),
        startText: matDate(start, "monthsign"),
        endText: matDate(end, "monthsign"),
        month: matDate(start, "month")
      })
      // }
    }
    let len = obj.week.length
    for (var m = 1; m <= 12; m++) {
      let monthFlag = true

      if (yearArray[i] == currentYear) {
        if (currentMonth <= m) {
          monthFlag = false
        }
      }
      obj.month.push({
        month: m,
        year: yearArray[i],
        monthFlag: monthFlag
      })
      let curMonthDays = new Date(yearArray[i], m, 0).getDate();
      let weeks = [
        [0, "日"],
        [1, "一"],
        [2, "二"],
        [3, "三"],
        [4, "四"],
        [5, "五"],
        [6, "六"]
      ]
      var first = new Date(yearArray[i], m - 1, 1);
      var last = new Date(yearArray[i], m, 0);
      var bweek = first.getDay();
      var fweek = weeks[0][0];
      var before = fweek ? (bweek || 7) - 1 : bweek;
      var total = before + last.getDate();
      var after = 7 - (total % 7 || 7);
      var days = Array(total + after).join(",").split(",");
      let dateArr = days.map(function (item, idx) {
        let str = "日一二三四五六".charAt(new Date(`${yearArray[i]}/${m}/${idx - before + 1}`).getDay())
        return idx >= before && idx < total
          ? {
            year: yearArray[i],
            month: formatDig(m),
            date: `${yearArray[i]}/${formatDig(m)}/${formatDig(idx - before + 1)}`,
            day: idx - before + 1,
            isSelected: new Date(`${yearArray[i]}/${m}/${idx - before + 1}`).getTime() > ms ? false : true,
            weekname: str
          }
          : {};
      });
      obj.dates.push({
        year: yearArray[i],
        month: formatDig(m),
        list: dateArr
      })
      let monthObj = {
        year: yearArray[i],
        month: m,
        monthArr: []
      }
      let num = 0
      for (var week = 0; week < len; week++) {
        if (m == obj.week[week].month) {
          num++
          let str = ""
          if (num == 1) {
            str = "一"
          } else if (num == 2) {
            str = "二"
          } else if (num == 3) {
            str = "三"
          } else if (num == 4) {
            str = "四"
          } else if (num == 5) {
            str = "五"
          } else if (num == 6) {
            str = "六"
          }
          let prevms = new Date((`${yearArray[i]}-${obj.week[week].start}`).replace(/-/g, "/")).getTime()
          let nextms = new Date((`${yearArray[i]}-${obj.week[week].end}`).replace(/-/g, "/")).getTime()
          let isFlag = false
          if (ms > prevms && ms > nextms) {
            isFlag = true
          }
          // console.log(prevms, nextms)
          monthObj.monthArr.push({
            start: yearArray[i] + "-" + obj.week[week].start,
            end: yearArray[i] + "-" + obj.week[week].end,
            year: yearArray[i],
            startText: obj.week[week].startText,
            endText: obj.week[week].endText,
            num: str,
            isFlag: isFlag,
            month: m
          })
          // console.log(monthObj)
        }

      }
      obj.monthWeek.push(monthObj)
    }
    arr.push(obj)
  }
  console.log(arr)
  return arr
}
// 判断字符串是否以特定字符串开始和结尾
export const judge = (startStr, endStr, str) => {
  let oldStr =String(str);
  let startRes = oldStr.startsWith(startStr);
  let endRes = oldStr.endsWith(endStr);
  let newStr = '';
  if(startRes&&endRes){
    newStr = oldStr.slice(1,oldStr.length-1);
  }else{
    newStr = oldStr;
  }
  return newStr
}